<template>
  <div class="header-content">
    
    <div class="btn-group">
      <el-tooltip
        v-show="!fullFlag"
        class="btn-item"
        content="新建会话"
        placement="bottom"
      >
        <add-icon @click="createDialog" />
      </el-tooltip>
      <el-tooltip
        v-show="!fullFlag"
        class="btn-item"
        content="历史会话"
        placement="bottom"
      >
        <refresh-icon @click="toggleHistory" />
      </el-tooltip>
      <el-tooltip
        v-if="pcFlag && !fullFlag"
        class="btn-item"
        content="窗口全屏"
        placement="bottom"
      >
        <full-screen @click="openFullWindow" />
      </el-tooltip>
      <el-tooltip v-if="!fullFlag" class="btn-item" content="关闭窗口" placement="bottom">
        <close-icon @click="closeDialog" />
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import AddIcon from "@/assets/svg/add.svg";
import CloseIcon from "@/assets/svg/close.svg";
import FullScreen from "@/assets/svg/full-screen.svg";
import RefreshIcon from "@/assets/svg/refresh.svg";

export default {
  props: {
    fullFlag: Boolean,
  },
  components: {
    AddIcon,
    CloseIcon,
    FullScreen,
    RefreshIcon,
  },
  data() {
    return {};
  },
  computed: {
    pcFlag() {
      return this.$store.state.ifPcStyle;
    }
  },
  watch: {},
  methods: {
    createDialog() {
      this.$emit("createDialog");
    },
    toggleHistory() {
      this.$emit("toggleHistory");
    },
    openFullWindow() {
      this.$emit("openFullWindow");
    },
    closeDialog() {
      this.$emit("closeDialog");
    }
  },
  mounted() {},
};
</script>

<style scoped lang="less">
.header-content {
  position: absolute;
  top: 14px;
  right: 0;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.btn-group {
  margin-right: 22px;
  display: flex;
  align-items: center;
  .btn-item {
    cursor: pointer;
    margin-left: 18px;
  }
}
</style>